// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link-copied-heading {
    font-family: var(--label-default-family);
    font-weight: 600;
    font-style: normal;
    font-size: 16px;
    line-height: var(--label-default-line-height);
    max-width: 100%;
}

.link-copied-message {
    font-family: var(--body-small-family);
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    line-height: var(--body-small-line-height);
    max-width: 100%;
    margin-top: 0.25rem;
}

#generate-link-container cat-pagination::part(label-text) {
    position: relative;
    display: inline-block;
}

#generate-link-container cat-pagination::part(label-text)::after {
    content: "";
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 27%;
    background: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/SharedList/CopyLinkToast.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,6CAA6C;IAC7C,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,0CAA0C;IAC1C,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,UAAU;IACV,iBAAiB;AACrB","sourcesContent":[".link-copied-heading {\n    font-family: var(--label-default-family);\n    font-weight: 600;\n    font-style: normal;\n    font-size: 16px;\n    line-height: var(--label-default-line-height);\n    max-width: 100%;\n}\n\n.link-copied-message {\n    font-family: var(--body-small-family);\n    font-weight: 400;\n    font-style: normal;\n    font-size: 14px;\n    line-height: var(--body-small-line-height);\n    max-width: 100%;\n    margin-top: 0.25rem;\n}\n\n#generate-link-container cat-pagination::part(label-text) {\n    position: relative;\n    display: inline-block;\n}\n\n#generate-link-container cat-pagination::part(label-text)::after {\n    content: \"\";\n    position: absolute;\n    right: 0;\n    top: 0;\n    height: 100%;\n    width: 27%;\n    background: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
